import { useEffect, useState, useMemo } from 'react';
import { useHistory  } from 'react-router-dom';
import useAxios from 'axios-hooks';

const useDataState = (idFromParams, route, redirectBasePath, bustCache = false) => {
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const isNew = !idFromParams;
    const history = useHistory ();

    // Fetch Data
    const [{ data, loading }, getData] = useAxios(
        { url: `${route}/${idFromParams}${bustCache ? '?bustCache=true' : ''}`, method: "get" },
        { manual: true }
    );

    // Upsert Submission (always POST)
    const [{}, submitForm] = useAxios(
        { url: `${route}/upsert`, method: "post" },
        { manual: true }
    );

    // Fetch data when an ID is provided
    useEffect(() => {
        if (idFromParams) {
            getData();
        }
    }, [idFromParams]);

    // Submit handler
    const handleSubmit = async (values, resetForm, idField) => {
        try {
            const result = await submitForm({ ...values });
            if (result?.status === 200) {
                const updatedData = { ...values };
                resetForm({ values: updatedData });
                if (isNew) {
                    const newId = result.data?.[idField] || updatedData?.[idField];
                    if (newId) {
                        history.push(`${redirectBasePath}/${newId}/wizard`);
                    } else {
                        history.push(redirectBasePath);
                    }
                } else {
                    getData();
                }
            }
            setShowSuccess(result?.status === 200);
            setShowError(result?.status !== 200);
        } catch (error) {
            setShowError(true);
        }
        
        // Dismiss success message after 5 seconds
        setTimeout(() => {
            setShowSuccess(false);
        }, 5000);
    };

    const isReady = useMemo(() => (!!data && !loading) || !idFromParams, [data, loading, idFromParams]);

    return {
        data,
        isReady,
        submitForm: handleSubmit,
        bustCache,
        showSuccess,
        setShowSuccess,
        showError,
        setShowError,
        refetchData: getData, // Expose refetch function if needed
    };
};

export default useDataState;
